<template>
  <div v-if="list_activites && list_activites.length > 0">
    <v-row>
      <v-col>
        <h3 class="font-weight-bold"><v-icon icon="mdi-ski-cross-country" color="primary" size="xs-small"></v-icon> Les
          activités</h3>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <div v-for="group in list_activites_grouped" :key="group.name">
          <div v-if="group.name == 'Sans groupe'">
            <div v-for="activite in group.list" :key="activite.id">
              <ActiviteItem :activite="activite" :key="activite.id" :all_activites="list_activites"></ActiviteItem>
            </div>
          </div>
          <div v-else>
            <h3 class="font-weight-bold ml-1 mt-6">{{ group.name }}</h3>
             <DescriptionGroupeActivitesVOLVIC50 v-if="mainStore.module.base == 'VOLVIC50'" :groupe="group.name"></DescriptionGroupeActivitesVOLVIC50>
            <div class="rounded bg-grey_3 bordered pa-1 my-3">
              <ActiviteItem v-for="activite in group.list" :activite="activite" :key="activite.id"
                :all_activites="list_activites"></ActiviteItem>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-divider></v-divider>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import ActiviteItem from "@/components/Home/Activites/Activite_Item.vue";
import DescriptionGroupeActivitesVOLVIC50 from "@/components/App/Hooks/VOLVIC50/DescriptionGroupeActivites.vue";

export default {

  components: { ActiviteItem, DescriptionGroupeActivitesVOLVIC50 },
  data() {
    return {
    };
  },
  computed: {
    ...mapStores(useMainStore),
    all_activites() {
      return this.mainStore.module.activites.list;
    },
    list_activites() {
      return this.mainStore.module.activites.visibles_accueil;
    },
    list_activites_grouped() {
      return this.mainStore.module.activites.visibles_accueil_grouped;
    }
  },

};
</script>

<style lang="scss" scoped></style>